import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { PuntosPeligroState } from '@/store/modules/puntos-peligro/types'
import { getters } from '@/store/modules/puntos-peligro/getters'
import { actions } from '@/store/modules/puntos-peligro/actions'
import { mutations } from '@/store/modules/puntos-peligro/mutations'

export const state: PuntosPeligroState = {
  punto_peligro_list: [],
  isLoaded: false,
  error: { state: false }
}

const namespaced: boolean = true

export const puntosPeligro: Module<PuntosPeligroState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
